import { useCallback, useState } from "react";

/**
 * Generic overtime tour hook. Each page uses its own storage key.
 */
export function useOvertimeTour(storageKey: string) {
  const [run, setRun] = useState(false);

  const startTour = useCallback(() => setRun(true), []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(storageKey, "true");
    }
  }, [storageKey]);

  const handleJoyrideCallback = useCallback(
    (data: { status?: string; type?: string }) => {
      if (
        data.status === "finished" ||
        data.status === "skipped" ||
        data.type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour],
  );

  return { run, startTour, stopTour, handleJoyrideCallback };
}
